/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Profile_Parq_PositiveInputs */

const en_us2_profile_parq_positive = /** @type {(inputs: Profile_Parq_PositiveInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 yes answer: the plan starts more conservatively.`);
	return /** @type {LocalizedString} */ (`${i?.count} yes answers: the plan starts more conservatively.`)
	
};

const pt_br2_profile_parq_positive = /** @type {(inputs: Profile_Parq_PositiveInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 resposta positiva: o plano começa mais conservador.`);
	return /** @type {LocalizedString} */ (`${i?.count} respostas positivas: o plano começa mais conservador.`)
	
};

const es_419_profile_parq_positive = /** @type {(inputs: Profile_Parq_PositiveInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 respuesta afirmativa: el plan empieza de forma más conservadora.`);
	return /** @type {LocalizedString} */ (`${i?.count} respuestas afirmativas: el plan empieza de forma más conservadora.`)
	
};

const pt_pt2_profile_parq_positive = /** @type {(inputs: Profile_Parq_PositiveInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 resposta positiva: o plano começa de forma mais conservadora.`);
	return /** @type {LocalizedString} */ (`${i?.count} respostas positivas: o plano começa de forma mais conservadora.`)
	
};

const fr_fr2_profile_parq_positive = /** @type {(inputs: Profile_Parq_PositiveInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 réponse « oui » : le programme démarre plus prudemment.`);
	return /** @type {LocalizedString} */ (`${i?.count} réponses « oui » : le programme démarre plus prudemment.`)
	
};

const de_de2_profile_parq_positive = /** @type {(inputs: Profile_Parq_PositiveInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Ja: Der Plan beginnt vorsichtiger.`);
	return /** @type {LocalizedString} */ (`${i?.count}-mal Ja: Der Plan beginnt vorsichtiger.`)
	
};

const it_it2_profile_parq_positive = /** @type {(inputs: Profile_Parq_PositiveInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 risposta sì: la scheda parte in modo più prudente.`);
	return /** @type {LocalizedString} */ (`${i?.count} risposte sì: la scheda parte in modo più prudente.`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 yes answer: the plan starts more conservatively." |
* | * | "{count} yes answers: the plan starts more conservatively." |
*
* @param {Profile_Parq_PositiveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_parq_positive = /** @type {((inputs: Profile_Parq_PositiveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Parq_PositiveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_parq_positive(inputs)
	if (locale === "es-419") return es_419_profile_parq_positive(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_parq_positive(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_parq_positive(inputs)
	if (locale === "de-DE") return de_de2_profile_parq_positive(inputs)
	if (locale === "it-IT") return it_it2_profile_parq_positive(inputs)
	return en_us2_profile_parq_positive(inputs)
});
export { profile_parq_positive as "profile.parq_positive" }